<div class='card-body'>
    <!-- Login Info -->
    <legend class='login_info'>Forgot Password</legend>

    <!-- Send OTP -->
    <form  [formGroup]="formGroup">
        <!-- User Id -->
        <br />
        <div class='row'>
            <div class='col-12'>
                <label for='userid'>
                    <span>Email Address</span>
                </label>
            </div>
            <div class='col-md-10 col-10'>
                <br />
                <input type='email' id='inputField' placeholder='example@xyz.com' formControlName="userid" />
            </div>
            <div class='col-md-2 col-2'>
                <br />
                <button mat-button class='btn sendOtp' type='submit'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                    </svg>
                </button>
            </div>
        </div>
    </form>

    <!-- Verify OTP -->
    <form  [formGroup]="formGroup">
        <!-- User Id -->
        <br />
        <div class='row'>
            <div class='col-12'>
                <label for='userid'>
                    <span>Verify OTP</span>
                </label>
            </div>
            <div class='col-md-10 col-10'>
                <br />
                <input type='email' id='inputField' placeholder='example@xyz.com' formControlName="userid" />
            </div>
            <div class='col-md-2 col-2'>
                <br />
                <button mat-button class='btn sendOtp' type='submit'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
                    </svg>
                </button>
            </div>
        </div>
    </form>

    <!-- Reset Password -->
    <form  [formGroup]="formGroup">
        <!-- User Id -->
        <br />
        <div class='row'>
            <div class='col-12' style='width:100%;'>
                <label for='userid'>
                    <span>Reset Password</span>
                </label>
            </div>
            <div class='col-md-5 col-6'>
                <br />
                <input type='email' id='inputField' placeholder='example@xyz.com' formControlName="userid" />
            </div>
            <div class='col-md-5 col-6'>
                <br />
                <input type='email' id='inputField' placeholder='example@xyz.com' formControlName="userid" />
            </div>
            <div class='col-md-2 col-12'>
                <br />
                <button mat-stroked-button class='btn sendOtp' type='submit'>
                    Confirm
                </button>
            </div>
        </div>
        <br />
    </form>

</div>

